import { EXPECTED_EMBEDDING_DIM } from '@/shared/config/terminal.config';

export class FaceEmbedding {
  private constructor(private readonly _vector: number[]) {}

  static from(vector: number[]): FaceEmbedding {
    if (vector.length !== EXPECTED_EMBEDDING_DIM) {
      throw new Error(
        `FaceEmbedding: expected ${EXPECTED_EMBEDDING_DIM}-d vector, got ${vector.length}-d`,
      );
    }
    return new FaceEmbedding(vector);
  }

  cosineSimilarity(other: FaceEmbedding): number {
    let dot = 0;
    for (let i = 0; i < this._vector.length; i++) {
      dot += (this._vector[i] ?? 0) * (other._vector[i] ?? 0);
    }
    return dot; // vectors are L2-normalized so dot product = cosine similarity
  }

  toArray(): number[] { return this._vector.slice(); }
  toJSON(): number[] { return this._vector; }
}
